import { memo, useMemo } from 'react';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
// @ts-expect-error not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import TimelineCallErrorBoundary from './TimelineCallErrorBoundary';
import TimelineCallMetadataWithDetails from './TimelineCallMetadataWithDetails';
// @ts-expect-error not typed

// @ts-expect-error not typed

import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from 'hubspot-apollo-client';
import { jsx as _jsx } from "react/jsx-runtime";
const apolloClient = createApolloClient();
const dfcClient = new DataFetchingClient();
function TimelineCallMetadata({
  message,
  callMetadata,
  ungatedForNextBestActions
}) {
  const callId = useMemo(() => callMetadata.get('callId'), [callMetadata]);
  return /*#__PURE__*/_jsx(ApolloProvider, {
    client: apolloClient,
    children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: dfcClient,
      children: /*#__PURE__*/_jsx(TimelineCallErrorBoundary, {
        children: /*#__PURE__*/_jsx(TimelineCallMetadataWithDetails, {
          callId: callId,
          message: message,
          callMetadata: callMetadata,
          ungatedForNextBestActions: ungatedForNextBestActions
        })
      })
    })
  });
}
TimelineCallMetadata.propTypes = {
  callMetadata: RecordPropType('CallMetadata').isRequired,
  message: RecordPropType('CommonMessage').isRequired
};
export default /*#__PURE__*/memo(TimelineCallMetadata);